import React, { useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Grid,
  TextField,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  FormHelperText,
  Typography,
  Divider,
} from "@material-ui/core";
import axios from "axios";
import { useForm } from "react-hook-form";
import apiConfigs from "../../config/config";
import { useDispatch, useSelector } from "react-redux";
import { createStaff, getRoles } from "../../store/action";
import Notification from "../../components/Notification/Notification";
import history from "../../utils/HistoryUtils";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },

  formControl: {
    width: "100%",
    "& > .MuiFormHelperText-root": {
      color: "red",
    },
  },
  footerBtn: {
    display: "flex",
    justifyContent: "flex-end",
    // marginTop: "24px",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const CreateStaff = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [designationItem, setDesignationItem] = useState([]);
  const [staffNotify, setStaffNotify] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const { staffError, staffSuccess } = useSelector((state) => state.staff);
  const { getRolesItem } = useSelector((state) => state.roles);

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact_number: "",
    role_id: "",
    designation_id: "",
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const getDesignation = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(`${apiConfigs.API_URL}api/organization/get-designation-list`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setDesignationItem(response.data.data);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const staffSubmit = async (datas) => {
    dispatch(createStaff(datas));
    setStaffNotify(true);
    reset();
  };

  useEffect(() => {
    dispatch(getRoles());
    getDesignation();
  }, []);

  const backPage = () => {
    history.goBack();
  };

  return (
    <>
      {staffNotify && staffSuccess?.message && (
        <Notification
          data={staffSuccess?.message ? "Staff member added successfully" : ""}
          status="success"
        />
      )}
      {staffNotify && staffError?.message && (
        <Notification data={staffError?.message} status="error" />
      )}

      <Paper className={classes.root}>
        {/* Header */}
        <Typography style={{ marginBottom: "10px" }}>
          Add New Staff
        </Typography>

        {/* Form */}
        <form onSubmit={handleSubmit(staffSubmit)} autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="First Name"
                variant="outlined"
                name="first_name"
                onChange={handleChange}
                fullWidth
                {...register("first_name", {
                  required: "Please enter first name",
                })}
                helperText={errors.first_name?.message ?? null}
                error={!!errors.first_name}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Last Name"
                variant="outlined"
                name="last_name"
                onChange={handleChange}
                fullWidth
                {...register("last_name", {
                  required: "Please enter last name",
                })}
                helperText={errors.last_name?.message ?? null}
                error={!!errors.last_name}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Email Address"
                variant="outlined"
                name="email"
                onChange={handleChange}
                fullWidth
                {...register("email", {
                  required: "Please enter email",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Enter a valid e-mail address",
                  },
                })}
                helperText={errors.email?.message ?? null}
                error={!!errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Contact Number"
                variant="outlined"
                name="contact_number"
                onChange={handleChange}
                fullWidth
                {...register("contact_number", {
                  required: "Please enter contact number",
                  minLength: {
                    value: 10,
                    message: "Number must have at least 10 digits",
                  },
                  pattern: /[0-9]/,
                })}
                helperText={errors.contact_number?.message ?? null}
                error={!!errors.contact_number}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={!!errors.role_id}
              >
                <InputLabel>Select Role</InputLabel>
                <Select
                  value={data.role_id}
                  {...register("role_id", {
                    required: "Please select role",
                  })}
                  onChange={handleChange}
                  name="role_id"
                  label="Role"
                >
                  <MenuItem value="">Select a Role</MenuItem>
                  {getRolesItem?.data &&
                    getRolesItem?.data
                      .filter((item) => item.role_name !== "SUPERADMIN")
                      .map((item) => (
                        <MenuItem value={item.id} key={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                </Select>
                <FormHelperText>
                  {errors.role_id?.message ?? null}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={!!errors.designation_id}
              >
                <InputLabel>Select Designation</InputLabel>
                <Select
                  value={data.designation_id}
                  {...register("designation_id", {
                    required: "Please select designation",
                  })}
                  onChange={handleChange}
                  name="designation_id"
                  label="Designation"
                >
                  <MenuItem value="">Select a Designation</MenuItem>
                  {designationItem?.data &&
                    designationItem?.data.map((item) => {
                      return (
                        <MenuItem value={item.id} key={item.id}>
                          {item.designation_name}
                        </MenuItem>
                      );
                    })}
                </Select>
                <FormHelperText>{errors.designation_id?.message ?? null}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          {/* Footer */}
          <Box className={classes.footerBtn}>
            <Button variant="outlined" color="primary" onClick={backPage}>
              Cancel
            </Button>
            <Button variant="contained" color="secondary" type="submit">
              Add Staff
            </Button>
          </Box>
        </form>
      </Paper>
    </>
  );
};

export default CreateStaff;
